module.exports = __webpack_public_path__ + "img/yiduiyi03.47c32e4e.jpg";